import { render, staticRenderFns } from "./TicketListItem.vue?vue&type=template&id=1b36e6d0&"
import script from "./TicketListItem.vue?vue&type=script&lang=ts&"
export * from "./TicketListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b36e6d0')) {
      api.createRecord('1b36e6d0', component.options)
    } else {
      api.reload('1b36e6d0', component.options)
    }
    module.hot.accept("./TicketListItem.vue?vue&type=template&id=1b36e6d0&", function () {
      api.rerender('1b36e6d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/tickets/TicketListItem.vue"
export default component.exports